module.exports = __webpack_public_path__ + "static/media/black.710a9fc6.png";